import { Input } from "@/components/ui/input";

export const MEALS = ["Standard", "Vegetarian", "Vegan", "Halal", "Gluten-free", "Kosher", "No lunch \u2013 I will not be eating"];
const sel = "h-10 w-full rounded-md border bg-white px-3 text-sm";

export const AttendeeFields = ({ i, name, onName, d, onChange }) => {
  const s = (k) => (x) => onChange({ ...d, [k]: x.target.value });
  return (
    <div className="space-y-2 rounded-md border p-4" data-testid={`attendee-block-${i}`}>
      <div className="text-xs font-bold uppercase tracking-wider text-[#475569]">Attendee {i + 1}</div>
      <div className="grid gap-2 sm:grid-cols-2">
        <label className="text-xs">Full name<Input value={name} required onChange={(x) => onName(x.target.value)} data-testid={`attendee-name-${i}`} /></label>
        <label className="text-xs">Name on badge<Input value={d.badge_name || ""} placeholder={name} onChange={s("badge_name")} data-testid={`attendee-badge-${i}`} /></label>
        <label className="text-xs">Email<Input type="email" value={d.email || ""} onChange={s("email")} data-testid={`attendee-email-${i}`} /></label>
        <label className="text-xs">Phone<Input value={d.phone || ""} onChange={s("phone")} data-testid={`attendee-phone-${i}`} /></label>
        <label className="text-xs">Meal choice<select className={sel} value={d.meal || ""} onChange={s("meal")} data-testid={`attendee-meal-${i}`}><option value="">Choose a meal</option>{MEALS.map((m) => <option key={m}>{m}</option>)}</select></label>
        <label className="text-xs">Allergy severity<select className={sel} value={d.allergy_severity || ""} onChange={s("allergy_severity")} data-testid={`attendee-severity-${i}`}><option value="">No allergies</option><option value="mild">Mild</option><option value="moderate">Moderate</option><option value="severe">Severe</option></select></label>
      </div>
      <label className="block text-xs">Allergies<Input value={d.allergies || ""} onChange={s("allergies")} placeholder="e.g. peanuts, shellfish" data-testid={`attendee-allergies-${i}`} /></label>
      <label className="block text-xs">Accessibility needs<Input value={d.accessibility || ""} onChange={s("accessibility")} placeholder="e.g. wheelchair access, hearing loop" data-testid={`attendee-access-${i}`} /></label>
    </div>
  );
};

export const getUtm = () => {
  try { return JSON.parse(localStorage.getItem("mct_utm") || "{}"); } catch { return {}; }
};

export const captureUtm = () => {
  const p = new URLSearchParams(window.location.search);
  const u = {};
  ["utm_source", "utm_medium", "utm_campaign", "utm_term", "utm_content", "ref"].forEach((k) => { if (p.get(k)) u[k] = p.get(k); });
  if (Object.keys(u).length) localStorage.setItem("mct_utm", JSON.stringify({ ...u, landing: window.location.pathname, at: new Date().toISOString() }));
};
